import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.table,
      stripe: "",
      "empty-text": "没有记录",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          type: "index",
          label: "序号",
          width: "50"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "name",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "regNo",
          label: "统一社会信用代码"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.creditCode?scope.row.creditCode:scope.row.regNo), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "belongOrg",
          label: "登记机关"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "operName",
          label: "法定代表人"
        })
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}